{
  "level": "sub05a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sub05a",
    "objects": "AREAS.E3:sub05a.e3",
    "mesh": "TREES.E3:sub05a.e3"
  },
  "spawn_point": {
    "position": [
      1914.0103658040364,
      -230.22158983018664,
      133.975341796875
    ],
    "facing_rad": 0.0,
    "look_point": [
      1914.0103658040364,
      -130.22158983018664,
      133.975341796875
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1321.548828125,
      -2491.50830078125,
      109.975341796875
    ],
    "bbox_max": [
      2015.62939453125,
      1591.8519287109375,
      616.1244506835938
    ],
    "vertex_count": 216,
    "vertices": [
      [
        1996.6407470703125,
        -1804.5487060546875,
        567.4754638671875
      ],
      [
        1996.3919677734375,
        -1805.9486083984375,
        567.4754638671875
      ],
      [
        1996.6407470703125,
        -1805.919921875,
        567.6806640625
      ],
      [
        1996.6407470703125,
        -1804.5487060546875,
        567.4754638671875
      ],
      [
        1996.3919677734375,
        -1805.9486083984375,
        567.4754638671875
      ],
      [
        1324.0269775390625,
        -2490.844482421875,
        609.5467529296875
      ],
      [
        1321.548828125,
        -2491.50830078125,
        609.5468139648438
      ],
      [
        1324.0269775390625,
        -2490.844482421875,
        609.5467529296875
      ],
      [
        1665.3392333984375,
        -2400.01123046875,
        578.8099365234375
      ],
      [
        1662.1815185546875,
        -2400.335693359375,
        577.634765625
      ],
      [
        1661.822265625,
        -2400.373779296875,
        577.501220703125
      ],
      [
        1662.1815185546875,
        -2400.335693359375,
        577.634765625
      ],
      [
        1321.548828125,
        -2491.467041015625,
        577.3600463867188
      ],
      [
        1326.317138671875,
        -2490.189453125,
        577.359619140625
      ],
      [
        1661.822265625,
        -2400.373779296875,
        577.501220703125
      ],
      [
        1326.3173828125,
        -2490.189453125,
        577.359619140625
      ],
      [
        1837.2972412109375,
        -2204.03759765625,
        616.1244506835938
      ],
      [
        1824.1339111328125,
        -2193.842041015625,
        609.4977416992188
      ],
      [
        2008.634765625,
        1342.0419921875,
        151.99774169921875
      ],
      [
        1967.46875,
        1341.7425537109375,
        135.99945068359375
      ],
      [
        1906.02099609375,
        1450.0,
        120.0
      ],
      [
        1906.02099609375,
        1400.0,
        120.0
      ],
      [
        1931.728759765625,
        1427.968505859375,
        132.00128173828125
      ],
      [
        1910.0,
        1427.968505859375,
        121.85755157470703
      ],
      [
        1931.728759765625,
        1417.968505859375,
        132.00128173828125
      ],
      [
        1910.0,
        1417.968505859375,
        121.85755157470703
      ],
      [
        1931.728759765625,
        1417.968505859375,
        132.00128173828125
      ],
      [
        1931.728759765625,
        1427.968505859375,
        132.00128173828125
      ],
      [
        1951.0,
        1406.0068359375,
        120.001220703125
      ],
      [
        1951.0,
        1353.199951171875,
        127.90291595458984
      ],
      [
        1951.0,
        1406.0147705078125,
        120.0
      ],
      [
        1954.469482421875,
        1415.0,
        120.0
      ],
      [
        1951.0,
        1406.0068359375,
        120.001220703125
      ],
      [
        1960.3743896484375,
        1453.431396484375,
        120.001220703125
      ],
      [
        1960.3743896484375,
        1430.284912109375,
        120.001220703125
      ],
      [
        1951.0,
        1353.199951171875,
        127.90291595458984
      ],
      [
        1966.550537109375,
        1353.199951171875,
        133.92919921875
      ],
      [
        1960.3743896484375,
        1453.431396484375,
        120.001220703125
      ],
      [
        1968.1175537109375,
        1353.199951171875,
        134.53643798828125
      ],
      [
        1967.46875,
        1341.7425537109375,
        135.99945068359375
      ],
      [
        1974.56298828125,
        1467.03125,
        120.00121307373047
      ],
      [
        1973.79296875,
        1453.431396484375,
        121.73780059814453
      ],
      [
        1969.311767578125,
        1453.431396484375,
        120.001220703125
      ],
      [
        1973.79296875,
        1453.431396484375,
        121.73780059814453
      ],
      [
        1969.311767578125,
        1453.431396484375,
        120.001220703125
      ],
      [
        1968.1175537109375,
        1353.199951171875,
        134.53643798828125
      ],
      [
        2009.25830078125,
        1353.199951171875,
        150.57156372070312
      ],
      [
        2008.634765625,
        1342.0419921875,
        151.99774169921875
      ],
      [
        2014.859619140625,
        1453.431396484375,
        137.76014709472656
      ],
      [
        2009.25830078125,
        1353.199951171875,
        150.57156372070312
      ],
      [
        2014.859619140625,
        1453.431396484375,
        137.7601318359375
      ],
      [
        2015.62939453125,
        1467.20654296875,
        135.99945068359375
      ],
      [
        2015.62939453125,
        1467.2066650390625,
        135.99945068359375
      ],
      [
        2008.634765625,
        1555.89404296875,
        120.00119018554688
      ],
      [
        1986.3349609375,
        1564.75634765625,
        109.97537231445312
      ],
      [
        1974.56298828125,
        1467.03125,
        120.00121307373047
      ],
      [
        2008.634765625,
        1555.89404296875,
        120.00119018554688
      ],
      [
        1996.7265625,
        1591.8519287109375,
        109.97538757324219
      ],
      [
        1996.7265625,
        1591.8519287109375,
        109.97538757324219
      ],
      [
        1986.3349609375,
        1564.7564697265625,
        109.97537231445312
      ],
      [
        1711.66015625,
        -2352.89697265625,
        609.4977416992188
      ],
      [
        1794.8348388671875,
        -2269.72216796875,
        609.4977416992188
      ],
      [
        1837.2972412109375,
        -2204.03759765625,
        616.1244506835938
      ],
      [
        1824.1339111328125,
        -2193.842041015625,
        609.4977416992188
      ],
      [
        1762.8992919921875,
        -2245.514404296875,
        593.4994506835938
      ],
      [
        1691.3599853515625,
        -2317.0537109375,
        593.4994506835938
      ],
      [
        1752.1820068359375,
        -2318.014892578125,
        600.1947021484375
      ],
      [
        1794.8348388671875,
        -2269.72216796875,
        609.4977416992188
      ],
      [
        1711.6602783203125,
        -2352.89697265625,
        609.4977416992188
      ],
      [
        1691.3599853515625,
        -2317.0537109375,
        593.4994506835938
      ],
      [
        1762.8992919921875,
        -2245.514404296875,
        593.4994506835938
      ],
      [
        1726.186279296875,
        -2287.019287109375,
        585.4825439453125
      ],
      [
        1639.427978515625,
        -2395.28515625,
        568.0614013671875
      ],
      [
        1642.519287109375,
        -2383.36328125,
        567.4754638671875
      ],
      [
        1638.041259765625,
        -2394.960693359375,
        567.4754638671875
      ],
      [
        1638.041259765625,
        -2394.960693359375,
        567.4754638671875
      ],
      [
        1639.4278564453125,
        -2395.28515625,
        568.0614013671875
      ],
      [
        1721.4853515625,
        -2352.7705078125,
        593.4994506835938
      ],
      [
        1689.6361083984375,
        -2328.33984375,
        577.501220703125
      ],
      [
        1721.4853515625,
        -2352.7705078125,
        593.4994506835938
      ],
      [
        1665.3392333984375,
        -2400.01123046875,
        578.8099365234375
      ],
      [
        1689.6361083984375,
        -2328.33984375,
        577.501220703125
      ],
      [
        1652.251708984375,
        -2377.343017578125,
        570.34619140625
      ],
      [
        1991.60546875,
        1243.0029296875,
        160.12802124023438
      ],
      [
        1991.6058349609375,
        1253.199951171875,
        158.6023406982422
      ],
      [
        1991.60546875,
        1243.0028076171875,
        160.12802124023438
      ],
      [
        2009.2926025390625,
        1353.199951171875,
        150.4930419921875
      ],
      [
        2008.634765625,
        1341.4404296875,
        151.99774169921875
      ],
      [
        2014.89990234375,
        1453.431396484375,
        137.66795349121094
      ],
      [
        2009.2926025390625,
        1353.199951171875,
        150.4930419921875
      ],
      [
        2014.89990234375,
        1453.431396484375,
        137.66793823242188
      ],
      [
        2015.62939453125,
        1466.4710693359375,
        135.99945068359375
      ],
      [
        2015.62939453125,
        1466.47119140625,
        135.99945068359375
      ],
      [
        2008.634765625,
        1555.27197265625,
        120.00119018554688
      ],
      [
        1991.6058349609375,
        1253.199951171875,
        158.6023406982422
      ],
      [
        2008.634765625,
        1341.4403076171875,
        151.99774169921875
      ],
      [
        2008.634765625,
        1555.27197265625,
        120.00119018554688
      ],
      [
        1996.7265625,
        1591.4339599609375,
        109.97538757324219
      ],
      [
        1996.7265625,
        1591.4339599609375,
        109.97538757324219
      ],
      [
        1991.61181640625,
        1578.1875,
        109.97537994384766
      ],
      [
        1991.5489501953125,
        1578.3515625,
        109.97537994384766
      ],
      [
        1986.3349609375,
        1564.5213623046875,
        109.97537231445312
      ],
      [
        1986.3349609375,
        1564.521484375,
        109.97537231445312
      ],
      [
        1996.6407470703125,
        -1805.919921875,
        567.6806640625
      ],
      [
        1990.59423828125,
        -1871.556396484375,
        577.501220703125
      ],
      [
        1956.494384765625,
        -1871.556396484375,
        577.501220703125
      ],
      [
        1639.7537841796875,
        -2394.501953125,
        567.4754638671875
      ],
      [
        1638.6943359375,
        -2395.113525390625,
        567.7514038085938
      ],
      [
        1886.9234619140625,
        -2105.07421875,
        593.4994506835938
      ],
      [
        1920.8436279296875,
        -1978.482421875,
        593.4994506835938
      ],
      [
        1956.494384765625,
        -1871.556396484375,
        577.501220703125
      ],
      [
        1933.55810546875,
        -2084.418212890625,
        577.501220703125
      ],
      [
        1990.59423828125,
        -1871.556396484375,
        577.501220703125
      ],
      [
        1969.0433349609375,
        -1978.482421875,
        593.4994506835938
      ],
      [
        1952.7655029296875,
        -2039.2320556640625,
        593.4994506835938
      ],
      [
        1902.8092041015625,
        -2067.548583984375,
        606.8255615234375
      ],
      [
        1920.8436279296875,
        -1978.482421875,
        593.4994506835938
      ],
      [
        1886.9234619140625,
        -2105.07421875,
        593.4994506835938
      ],
      [
        1952.7655029296875,
        -2039.2320556640625,
        593.4994506835938
      ],
      [
        1969.0433349609375,
        -1978.482421875,
        593.4994506835938
      ],
      [
        1952.6785888671875,
        -2027.427490234375,
        600.8226318359375
      ],
      [
        1946.7567138671875,
        -2061.6572265625,
        593.4994506835938
      ],
      [
        1893.9769287109375,
        -2104.874755859375,
        609.4977416992188
      ],
      [
        1899.1929931640625,
        -2085.408203125,
        609.4977416992188
      ],
      [
        1946.7567138671875,
        -2061.6572265625,
        593.4994506835938
      ],
      [
        1942.0819091796875,
        -2059.12109375,
        605.5646362304688
      ],
      [
        1900.587158203125,
        -2097.20947265625,
        611.263427734375
      ],
      [
        1899.1929931640625,
        -2085.408447265625,
        609.4977416992188
      ],
      [
        1893.9769287109375,
        -2104.875,
        609.4977416992188
      ],
      [
        1933.713623046875,
        -2084.149658203125,
        609.3093872070312
      ],
      [
        1903.025634765625,
        -2117.8515625,
        614.3518676757812
      ],
      [
        1930.654296875,
        -2089.45654296875,
        610.1033935546875
      ],
      [
        1904.4251708984375,
        -2129.69873046875,
        616.1244506835938
      ],
      [
        1904.4251708984375,
        -2129.69873046875,
        616.1244506835938
      ],
      [
        1933.292724609375,
        -2085.408447265625,
        609.4977416992188
      ],
      [
        1933.292724609375,
        -2085.408447265625,
        609.4977416992188
      ],
      [
        1953.6722412109375,
        -1945.90625,
        616.1244506835938
      ],
      [
        1951.5859375,
        -1889.874755859375,
        609.4977416992188
      ],
      [
        1951.5859375,
        -1889.8746337890625,
        609.4977416992188
      ],
      [
        1960.2252197265625,
        -1831.50830078125,
        593.4994506835938
      ],
      [
        1951.0,
        1385.70654296875,
        120.001220703125
      ],
      [
        1956.7803955078125,
        1353.199951171875,
        120.001220703125
      ],
      [
        1951.0,
        1385.70654296875,
        120.001220703125
      ],
      [
        1951.0,
        1353.199951171875,
        124.86381530761719
      ],
      [
        1951.0,
        1353.199951171875,
        124.86381530761719
      ],
      [
        1956.7803955078125,
        1353.199951171875,
        120.001220703125
      ],
      [
        1965.1888427734375,
        -1966.3704833984375,
        609.4977416992188
      ],
      [
        1953.6722412109375,
        -1945.90625,
        616.1244506835938
      ],
      [
        1960.2252197265625,
        -1831.50830078125,
        593.4994506835938
      ],
      [
        1979.4525146484375,
        -1939.6346435546875,
        593.4994506835938
      ],
      [
        1965.1888427734375,
        -1966.3704833984375,
        609.4977416992188
      ],
      [
        1979.4525146484375,
        -1939.6346435546875,
        593.4994506835938
      ],
      [
        1986.3638916015625,
        -1892.545654296875,
        580.6416015625
      ],
      [
        1986.3349609375,
        1254.023193359375,
        109.975341796875
      ],
      [
        1986.4813232421875,
        1253.199951171875,
        109.975341796875
      ],
      [
        1986.3349609375,
        1254.023193359375,
        109.975341796875
      ],
      [
        2008.634765625,
        1254.785888671875,
        120.001220703125
      ],
      [
        2008.634765625,
        1254.785888671875,
        120.001220703125
      ],
      [
        2008.4666748046875,
        1253.199951171875,
        119.85968017578125
      ],
      [
        2012.3582763671875,
        1353.199951171875,
        128.51760864257812
      ],
      [
        2009.07958984375,
        1453.431396484375,
        121.0185317993164
      ],
      [
        2012.3582763671875,
        1353.199951171875,
        128.51760864257812
      ],
      [
        2009.07958984375,
        1453.431396484375,
        121.0185317993164
      ],
      [
        2008.634765625,
        1467.028564453125,
        120.00121307373047
      ],
      [
        2008.634765625,
        1467.0284423828125,
        120.00121307373047
      ],
      [
        2003.6981201171875,
        1570.2630615234375,
        115.84495544433594
      ],
      [
        2003.6982421875,
        1315.860107421875,
        153.91236877441406
      ],
      [
        2003.644287109375,
        1570.4266357421875,
        115.79959106445312
      ],
      [
        2008.102783203125,
        1478.1519775390625,
        119.55337524414062
      ],
      [
        2003.63671875,
        1315.541259765625,
        153.9362335205078
      ],
      [
        1964.2247314453125,
        -1906.523681640625,
        616.1244506835938
      ],
      [
        1963.1976318359375,
        -1846.5391845703125,
        609.4977416992188
      ],
      [
        1962.51416015625,
        1435.82666015625,
        120.001220703125
      ],
      [
        1967.9228515625,
        1353.199951171875,
        120.001220703125
      ],
      [
        1963.1976318359375,
        -1846.539306640625,
        609.4977416992188
      ],
      [
        1967.9228515625,
        1353.199951171875,
        120.001220703125
      ],
      [
        1962.5133056640625,
        1353.199951171875,
        132.36465454101562
      ],
      [
        1969.8927001953125,
        -1948.8155517578125,
        609.4977416992188
      ],
      [
        1964.2247314453125,
        -1906.523681640625,
        616.1244506835938
      ],
      [
        1969.8927001953125,
        -1948.8155517578125,
        609.4977416992188
      ],
      [
        1974.45068359375,
        -1949.0101318359375,
        599.1095581054688
      ],
      [
        1967.93212890625,
        1353.199951171875,
        120.001220703125
      ],
      [
        1967.21337890625,
        1364.038818359375,
        120.001220703125
      ],
      [
        1967.93212890625,
        1353.199951171875,
        120.001220703125
      ],
      [
        1967.2379150390625,
        1353.199951171875,
        121.56649780273438
      ],
      [
        1970.786376953125,
        1353.199951171875,
        128.5178985595703
      ],
      [
        1974.11181640625,
        1453.431396484375,
        121.01876068115234
      ],
      [
        1973.6605224609375,
        1453.431396484375,
        120.001220703125
      ],
      [
        1967.4710693359375,
        1360.152587890625,
        120.001220703125
      ],
      [
        1970.786376953125,
        1353.199951171875,
        128.5178985595703
      ],
      [
        1967.470947265625,
        1353.199951171875,
        121.04106903076172
      ],
      [
        1974.11181640625,
        1453.431396484375,
        121.01876068115234
      ],
      [
        1973.6605224609375,
        1453.431396484375,
        120.001220703125
      ],
      [
        1972.75390625,
        -1874.692138671875,
        616.1244506835938
      ],
      [
        1972.75390625,
        -1874.692138671875,
        616.1244506835938
      ],
      [
        1967.4481201171875,
        -1930.575439453125,
        612.3557739257812
      ],
      [
        1972.8514404296875,
        -1874.328125,
        616.1244506835938
      ],
      [
        1974.562744140625,
        -1804.5487060546875,
        609.5418090820312
      ],
      [
        1972.8514404296875,
        -1874.328125,
        616.1244506835938
      ],
      [
        1996.7265625,
        1564.9527587890625,
        109.97537994384766
      ],
      [
        2008.631591796875,
        1467.093994140625,
        119.99857330322266
      ],
      [
        1996.7265625,
        1564.9527587890625,
        109.97537994384766
      ],
      [
        1991.6165771484375,
        1578.1998291015625,
        109.97537994384766
      ],
      [
        1991.5137939453125,
        -1804.6795654296875,
        616.1244506835938
      ],
      [
        1991.5137939453125,
        -1804.6795654296875,
        616.1244506835938
      ],
      [
        1991.5059814453125,
        -1804.5487060546875,
        616.1078491210938
      ],
      [
        1975.8544921875,
        1414.0,
        118.90119934082031
      ],
      [
        1975.8544921875,
        1424.0,
        118.90119934082031
      ],
      [
        1974.68017578125,
        1424.0,
        119.90119934082031
      ],
      [
        1974.68017578125,
        1414.0,
        119.90119934082031
      ],
      [
        1974.68017578125,
        1414.0,
        119.90119934082031
      ],
      [
        1975.8544921875,
        1414.0,
        118.90119934082031
      ],
      [
        1974.68017578125,
        1424.0,
        119.90119934082031
      ],
      [
        1975.8544921875,
        1424.0,
        118.90119934082031
      ],
      [
        1969.080322265625,
        1353.199951171875,
        124.6704330444336
      ],
      [
        1973.9078369140625,
        1453.431396484375,
        120.55892944335938
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.6398785710334778,
        0.11373113095760345,
        0.7600135207176208
      ],
      "plane_d": 1051.552001953125,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.643905520439148,
        0.1132064163684845,
        0.7566835880279541
      ],
      "plane_d": 1060.616455078125,
      "bbox_min": [
        1996.3919677734375,
        -1805.9486083984375,
        109.975341796875
      ],
      "bbox_max": [
        2008.548828125,
        1253.199951171875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.14797283709049225,
        0.9889914393424988
      ],
      "plane_d": -294.2042236328125,
      "bbox_min": [
        1996.3919677734375,
        -1805.9486083984375,
        109.975341796875
      ],
      "bbox_max": [
        2008.548828125,
        1253.199951171875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -567.4754638671875,
      "bbox_min": [
        1996.3919677734375,
        -1805.9486083984375,
        567.4754638671875
      ],
      "bbox_max": [
        1996.76708984375,
        -1804.5487060546875,
        567.4754638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385160088539124,
        0.17108990252017975,
        0.7503501772880554
      ],
      "plane_d": 1157.9024658203125,
      "bbox_min": [
        1996.6407470703125,
        -1805.919921875,
        567.4754638671875
      ],
      "bbox_max": [
        2008.548828125,
        -1804.5487060546875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3578789532184601,
        -0.1381853073835373,
        -0.9234866499900818
      ],
      "plane_d": -393.11285400390625,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35997137427330017,
        -0.13805317878723145,
        -0.9226927757263184
      ],
      "plane_d": -397.5306701660156,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2378382533788681,
        0.8878090977668762,
        -0.39398977160453796
      ],
      "plane_d": 2766.45361328125,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863905668258667,
        0.8897825479507446,
        -0.3890223801136017
      ],
      "plane_d": 2769.49462890625,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        593.4994506835938
      ],
      "bbox_max": [
        1665.048828125,
        -2399.50830078125,
        609.5468139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09693778306245804,
        0.3614393472671509,
        -0.9273427128791809
      ],
      "plane_d": 1593.8961181640625,
      "bbox_min": [
        1321.548828125,
        -2491.634765625,
        609.4977416992188
      ],
      "bbox_max": [
        1665.048828125,
        -2399.50830078125,
        609.5468139648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23863889276981354,
        0.8897818922996521,
        0.38902392983436584
      ],
      "plane_d": 2307.72265625,
      "bbox_min": [
        1321.548828125,
        -2498.62939453125,
        577.359619140625
      ],
      "bbox_max": [
        1662.1815185546875,
        -2400.335693359375,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7371826171875,
      "bbox_min": [
        1321.548828125,
        -2491.634765625,
        577.359619140625
      ],
      "bbox_max": [
        1661.822265625,
        -2400.373779296875,
        577.501220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.09693778306245804,
        0.3614393472671509,
        -0.9273427128791809
      ],
      "plane_d": 1593.8961181640625,
      "bbox_min": [
        1321.548828125,
        -2491.50830078125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09648174792528152,
        -0.3596065044403076,
        -0.9281026721000671
      ],
      "plane_d": -445.58453369140625,
      "bbox_min": [
        1321.548828125,
        -2491.467041015625,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26329389214515686,
        -0.26329389214515686,
        -0.9280908107757568
      ],
      "plane_d": -492.2392578125,
      "bbox_min": [
        1647.9989013671875,
        -2384.785888671875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3616013824939728,
        -2.8452538458623167e-07,
        -0.9323328733444214
      ],
      "plane_d": 868.0380249023438,
      "bbox_min": [
        1878.2073974609375,
        1253.199951171875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.62445068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.42300987243652344,
        0.0,
        -0.9061251878738403
      ],
      "plane_d": -697.5306396484375,
      "bbox_min": [
        1878.2073974609375,
        1353.199951171875,
        120.0
      ],
      "bbox_max": [
        1974.56298828125,
        1460.0,
        151.99774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1878.2073974609375,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1931.728759765625,
        1460.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1878.2073974609375,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1931.728759765625,
        1460.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1451.09716796875,
      "bbox_min": [
        1878.2073974609375,
        1402.94091796875,
        120.0
      ],
      "bbox_max": [
        1931.728759765625,
        1447.05908203125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2188.73779296875,
      "bbox_min": [
        1878.2073974609375,
        1425.0,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1447.05908203125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1427.968505859375,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        121.85755157470703
      ],
      "bbox_max": [
        1931.728759765625,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1417.968505859375,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        121.85755157470703
      ],
      "bbox_max": [
        1931.728759765625,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.00128173828125,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        132.00128173828125
      ],
      "bbox_max": [
        1931.728759765625,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1906.02099609375,
        1353.199951171875,
        120.0
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        151.99774169921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1906.02099609375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1450.0,
        132.00128173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1427.968505859375,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        120.001220703125
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1417.968505859375,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        120.001220703125
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.00128173828125,
      "bbox_min": [
        1931.728759765625,
        1417.968505859375,
        132.00128173828125
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        132.00128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.0
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        151.99774169921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        151.99774169921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1453.431396484375,
      "bbox_min": [
        1951.0,
        1453.431396484375,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        151.99774169921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3634515106678009,
        -2.8430577003746293e-07,
        -0.9316132068634033
      ],
      "plane_d": -576.0543823242188,
      "bbox_min": [
        1960.3743896484375,
        1253.199951171875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.62445068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9141523838043213,
        1.2370934143746126e-07,
        0.4053707718849182
      ],
      "plane_d": -1853.6966552734375,
      "bbox_min": [
        1960.3743896484375,
        1341.7425537109375,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1960.3743896484375,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1973.79296875,
        1453.431396484375,
        135.99945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1453.431396484375,
      "bbox_min": [
        1960.3743896484375,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1973.79296875,
        1453.431396484375,
        135.99945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1966.550537109375,
        1353.199951171875,
        133.92919921875
      ],
      "bbox_max": [
        1968.1175537109375,
        1353.199951171875,
        135.99945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162545204162598,
        -1.2225235934693046e-07,
        -0.400596559047699
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        1967.46875,
        1342.0419921875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1967.46875,
        1467.03125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483832597732544,
        -2.3233462798089022e-07,
        0.7613141536712646
      ],
      "plane_d": -1371.6317138671875,
      "bbox_min": [
        1967.46875,
        1467.03125,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        1967.46875,
        1555.89404296875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -3.0517577442878974e-07,
        1.0
      ],
      "plane_d": -109.97489929199219,
      "bbox_min": [
        1967.46875,
        1564.7564697265625,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1653.431396484375,
      "bbox_min": [
        1967.46875,
        1653.431396484375,
        109.97540283203125
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        158.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26462268829345703,
        0.26462268829345703,
        -0.927334725856781
      ],
      "plane_d": 1640.7825927734375,
      "bbox_min": [
        1647.9989013671875,
        -2384.785888671875,
        585.4825439453125
      ],
      "bbox_max": [
        1837.2972412109375,
        -2193.842041015625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513238549232483,
        -0.6513241529464722,
        -0.3892994523048401
      ],
      "plane_d": -2379.72705078125,
      "bbox_min": [
        1647.9989013671875,
        -2369.97705078125,
        585.4825439453125
      ],
      "bbox_max": [
        1824.1339111328125,
        -2193.842041015625,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.649912416934967,
        0.6499121189117432,
        -0.3939899504184723
      ],
      "plane_d": 2881.7412109375,
      "bbox_min": [
        1691.3599853515625,
        -2352.89697265625,
        585.4825439453125
      ],
      "bbox_max": [
        1794.8348388671875,
        -2245.514404296875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1691.3599853515625,
        -2317.0537109375,
        585.4825439453125
      ],
      "bbox_max": [
        1762.8992919921875,
        -2245.514404296875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7371826171875,
      "bbox_min": [
        1321.548828125,
        -2491.467041015625,
        567.475341796875
      ],
      "bbox_max": [
        1752.1820068359375,
        -2287.019287109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16998730599880219,
        0.634684145450592,
        0.7538437843322754
      ],
      "plane_d": 1370.701904296875,
      "bbox_min": [
        1321.548828125,
        -2491.467041015625,
        567.475341796875
      ],
      "bbox_max": [
        1752.1820068359375,
        -2287.019287109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.649912416934967,
        0.6499121189117432,
        -0.3939899504184723
      ],
      "plane_d": 2881.7412109375,
      "bbox_min": [
        1644.4989013671875,
        -2405.656982421875,
        570.34619140625
      ],
      "bbox_max": [
        1752.1820068359375,
        -2287.019287109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513238549232483,
        -0.6513241529464722,
        -0.3892994523048401
      ],
      "plane_d": -2379.72705078125,
      "bbox_min": [
        1644.4989013671875,
        -2399.50830078125,
        570.34619140625
      ],
      "bbox_max": [
        1711.66015625,
        -2317.0537109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26462268829345703,
        0.26462268829345703,
        -0.927334725856781
      ],
      "plane_d": 1640.7825927734375,
      "bbox_min": [
        1647.9989013671875,
        -2399.50830078125,
        570.34619140625
      ],
      "bbox_max": [
        1711.66015625,
        -2328.33984375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46439480781555176,
        -0.46439507603645325,
        0.7541053295135498
      ],
      "plane_d": -2301.424560546875,
      "bbox_min": [
        1647.9989013671875,
        -2377.343017578125,
        570.34619140625
      ],
      "bbox_max": [
        1689.6361083984375,
        -2328.33984375,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35971036553382874,
        -0.1380680948495865,
        -0.922792375087738
      ],
      "plane_d": 1035.78515625,
      "bbox_min": [
        1974.56298828125,
        -1804.5487060546875,
        109.97537231445312
      ],
      "bbox_max": [
        2015.62939453125,
        1591.8519287109375,
        616.1244506835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9162545800209045,
        -0.0,
        -0.40059658885002136
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        1991.548828125,
        1253.199951171875,
        109.97537994384766
      ],
      "bbox_max": [
        2015.62939453125,
        1591.8519287109375,
        158.62445068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1991.548828125,
        1253.199951171875,
        109.97537994384766
      ],
      "bbox_max": [
        2015.62939453125,
        1591.8519287109375,
        158.62445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3616013824939728,
        -0.0,
        -0.9323328733444214
      ],
      "plane_d": 868.03759765625,
      "bbox_min": [
        1991.548828125,
        1253.199951171875,
        109.97537994384766
      ],
      "bbox_max": [
        2008.634765625,
        1591.8519287109375,
        158.62445068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -3.0517577442878974e-07,
        1.0
      ],
      "plane_d": -109.97489929199219,
      "bbox_min": [
        1991.5489501953125,
        1578.1875,
        109.97537994384766
      ],
      "bbox_max": [
        1996.7265625,
        1591.8519287109375,
        109.97538757324219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483832597732544,
        -2.3233462798089022e-07,
        0.7613141536712646
      ],
      "plane_d": -1371.6317138671875,
      "bbox_min": [
        1974.56298828125,
        1467.03125,
        109.97537231445312
      ],
      "bbox_max": [
        1991.61181640625,
        1578.3515625,
        120.00121307373047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -3.0517577442878974e-07,
        1.0
      ],
      "plane_d": -109.97489929199219,
      "bbox_min": [
        1986.3349609375,
        1564.521484375,
        109.97537231445312
      ],
      "bbox_max": [
        1991.61181640625,
        1578.3515625,
        109.97537994384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.14797283709049225,
        0.9889914393424988
      ],
      "plane_d": -294.2042236328125,
      "bbox_min": [
        1638.041259765625,
        -2400.373779296875,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -567.4754638671875,
      "bbox_min": [
        1638.041259765625,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1996.6407470703125,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6499118804931641,
        0.6499118804931641,
        0.3939912021160126
      ],
      "plane_d": 2414.07373046875,
      "bbox_min": [
        1638.041259765625,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1996.6407470703125,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385160088539124,
        0.17108990252017975,
        0.7503501772880554
      ],
      "plane_d": 1157.9024658203125,
      "bbox_min": [
        1638.041259765625,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1996.6407470703125,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.762451171875,
      "bbox_min": [
        1638.041259765625,
        -2395.113525390625,
        567.4754638671875
      ],
      "bbox_max": [
        1990.59423828125,
        -1804.5487060546875,
        606.8255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        1886.9234619140625,
        -2105.07421875,
        577.501220703125
      ],
      "bbox_max": [
        1990.59423828125,
        -1871.556396484375,
        606.8255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897264003753662,
        -0.23840099573135376,
        -0.38929685950279236
      ],
      "plane_d": -1949.6500244140625,
      "bbox_min": [
        1886.9234619140625,
        -2105.07421875,
        593.4994506835938
      ],
      "bbox_max": [
        1969.0433349609375,
        -1978.482421875,
        606.8255615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        1952.6785888671875,
        -2039.2320556640625,
        593.4994506835938
      ],
      "bbox_max": [
        1969.0433349609375,
        -1978.482421875,
        600.8226318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.649912416934967,
        0.6499121189117432,
        -0.3939899504184723
      ],
      "plane_d": 2881.7412109375,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1952.7655029296875,
        -2027.427490234375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513234972953796,
        -0.6513237953186035,
        0.38930073380470276
      ],
      "plane_d": -2841.82470703125,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1952.7655029296875,
        -2027.427490234375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        577.501220703125
      ],
      "bbox_max": [
        1952.7655029296875,
        -2027.427490234375,
        611.263427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        577.501220703125
      ],
      "bbox_max": [
        1952.7655029296875,
        -2027.427490234375,
        611.263427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897258043289185,
        -0.23840104043483734,
        0.38929808139801025
      ],
      "plane_d": -2411.74462890625,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        577.501220703125
      ],
      "bbox_max": [
        1900.587158203125,
        -2085.408447265625,
        611.263427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1893.9769287109375,
        -2104.875,
        609.4977416992188
      ],
      "bbox_max": [
        1900.587158203125,
        -2085.408447265625,
        611.263427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26462268829345703,
        0.26462268829345703,
        -0.927334725856781
      ],
      "plane_d": 1640.7825927734375,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1946.7567138671875,
        -2059.12109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513238549232483,
        -0.6513241529464722,
        -0.3892994523048401
      ],
      "plane_d": -2379.72705078125,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1946.7567138671875,
        -2059.12109375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897264003753662,
        -0.23840099573135376,
        -0.38929685950279236
      ],
      "plane_d": -1949.6500244140625,
      "bbox_min": [
        1880.914794921875,
        -2130.9990234375,
        593.4994506835938
      ],
      "bbox_max": [
        1946.7567138671875,
        -2059.12109375,
        614.3518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26329389214515686,
        -0.26329389214515686,
        -0.9280908107757568
      ],
      "plane_d": -492.2392578125,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1946.7567138671875,
        -2061.6572265625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        1886.97705078125,
        -2139.548828125,
        609.4977416992188
      ],
      "bbox_max": [
        1930.654296875,
        -2089.45654296875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1886.97705078125,
        -2139.548828125,
        609.4977416992188
      ],
      "bbox_max": [
        1904.4251708984375,
        -2117.8515625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1946.7567138671875,
        -2061.6572265625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1946.7567138671875,
        -2061.6572265625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17123213410377502,
        0.638451099395752,
        0.7503730654716492
      ],
      "plane_d": 1383.7371826171875,
      "bbox_min": [
        1638.6943359375,
        -2400.373779296875,
        567.4754638671875
      ],
      "bbox_max": [
        1665.3392333984375,
        -2389.304931640625,
        578.8099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23783810436725616,
        0.8878085017204285,
        0.393991082906723
      ],
      "plane_d": 2298.78564453125,
      "bbox_min": [
        1661.822265625,
        -2400.373779296875,
        577.501220703125
      ],
      "bbox_max": [
        1665.3392333984375,
        -2399.50830078125,
        578.8099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6395595073699951,
        0.11372952163219452,
        0.7602823972702026
      ],
      "plane_d": -1496.6112060546875,
      "bbox_min": [
        1899.1929931640625,
        -2129.69873046875,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6442214846611023,
        0.11318203806877136,
        0.7564182281494141
      ],
      "plane_d": -1504.666748046875,
      "bbox_min": [
        1899.1929931640625,
        -2129.69873046875,
        109.975341796875
      ],
      "bbox_max": [
        1986.4813232421875,
        1385.70654296875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1899.1929931640625,
        -2129.69873046875,
        120.001220703125
      ],
      "bbox_max": [
        1986.3671875,
        1385.70654296875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897264003753662,
        -0.23840099573135376,
        -0.38929685950279236
      ],
      "plane_d": -1949.6500244140625,
      "bbox_min": [
        1899.1929931640625,
        -2129.69873046875,
        120.001220703125
      ],
      "bbox_max": [
        1986.3671875,
        1385.70654296875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1956.7803955078125,
        1385.70654296875,
        124.86381530761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1956.7803955078125,
        1385.70654296875,
        124.86381530761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1956.7803955078125,
        1353.199951171875,
        124.86381530761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        1904.4251708984375,
        -2129.69873046875,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897258043289185,
        -0.23840104043483734,
        0.38929808139801025
      ],
      "plane_d": -2411.74462890625,
      "bbox_min": [
        1920.8436279296875,
        -2085.408447265625,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        1956.494384765625,
        -1978.482421875,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        593.4994506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6343684792518616,
        -0.16997818648815155,
        0.7541115283966064
      ],
      "plane_d": -1994.762451171875,
      "bbox_min": [
        1956.494384765625,
        -1871.556396484375,
        567.4754638671875
      ],
      "bbox_max": [
        1986.3671875,
        -1804.5487060546875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483878493309021,
        0.0,
        0.7613101601600647
      ],
      "plane_d": -1371.6407470703125,
      "bbox_min": [
        1974.56298828125,
        1253.199951171875,
        109.975341796875
      ],
      "bbox_max": [
        1986.4813232421875,
        1254.023193359375,
        120.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.975341796875,
      "bbox_min": [
        1986.3349609375,
        1253.199951171875,
        109.975341796875
      ],
      "bbox_max": [
        1986.4813232421875,
        1254.023193359375,
        109.975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9123549461364746,
        0.06057443469762802,
        0.40489399433135986
      ],
      "plane_d": 1707.9921875,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146111607551575,
        0.05985564738512039,
        0.3998796045780182
      ],
      "plane_d": 1714.12255859375,
      "bbox_min": [
        2008.4666748046875,
        -1804.5487060546875,
        119.85968017578125
      ],
      "bbox_max": [
        2015.62939453125,
        1254.785888671875,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        0.0,
        0.4005979001522064
      ],
      "plane_d": 1792.347412109375,
      "bbox_min": [
        2008.4666748046875,
        1253.199951171875,
        119.85968017578125
      ],
      "bbox_max": [
        2015.62939453125,
        1254.785888671875,
        135.99945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.64405757188797,
        0.0,
        0.7649770975112915
      ],
      "plane_d": 1201.878173828125,
      "bbox_min": [
        2008.4666748046875,
        1253.199951171875,
        119.85968017578125
      ],
      "bbox_max": [
        2008.634765625,
        1254.785888671875,
        120.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146128296852112,
        -0.05983559042215347,
        -0.3998787999153137
      ],
      "plane_d": 1972.8896484375,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162545800209045,
        -0.0,
        -0.40059658885002136
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        2003.6981201171875,
        1253.199951171875,
        115.84495544433594
      ],
      "bbox_max": [
        2015.62939453125,
        1570.2630615234375,
        153.91236877441406
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9162539839744568,
        0.0,
        0.40059787034988403
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        2003.6981201171875,
        1253.199951171875,
        115.84495544433594
      ],
      "bbox_max": [
        2015.62939453125,
        1570.2630615234375,
        153.91236877441406
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        2003.6981201171875,
        1253.199951171875,
        115.84495544433594
      ],
      "bbox_max": [
        2008.634765625,
        1570.2630615234375,
        153.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3616013824939728,
        -0.0,
        -0.9323328733444214
      ],
      "plane_d": 868.03759765625,
      "bbox_min": [
        2003.6982421875,
        1253.199951171875,
        151.99774169921875
      ],
      "bbox_max": [
        2008.634765625,
        1341.4403076171875,
        153.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9123566746711731,
        -0.06055442988872528,
        -0.404893159866333
      ],
      "plane_d": 1970.02099609375,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        2003.63671875,
        1253.199951171875,
        115.79959106445312
      ],
      "bbox_max": [
        2008.634765625,
        1570.4266357421875,
        153.9362335205078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3616013824939728,
        -0.0,
        -0.9323328733444214
      ],
      "plane_d": 868.03759765625,
      "bbox_min": [
        2003.63671875,
        1253.199951171875,
        151.99774169921875
      ],
      "bbox_max": [
        2008.634765625,
        1315.860107421875,
        153.9362335205078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9144980311393738,
        0.059862565249204636,
        0.40013715624809265
      ],
      "plane_d": -1928.6845703125,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        120.0
      ],
      "bbox_max": [
        1974.45068359375,
        1435.82666015625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1951.0,
        -1966.3704833984375,
        120.0
      ],
      "bbox_max": [
        1974.45068359375,
        1435.82666015625,
        616.1244506835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1967.9228515625,
        1353.199951171875,
        132.36465454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        1953.6722412109375,
        -1966.3704833984375,
        577.501220703125
      ],
      "bbox_max": [
        1974.45068359375,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897258043289185,
        -0.23840104043483734,
        0.38929808139801025
      ],
      "plane_d": -2411.74462890625,
      "bbox_min": [
        1960.2252197265625,
        -1966.3704833984375,
        577.501220703125
      ],
      "bbox_max": [
        1974.45068359375,
        -1804.5487060546875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        1965.1888427734375,
        -1966.3704833984375,
        599.1095581054688
      ],
      "bbox_max": [
        1974.45068359375,
        -1948.8155517578125,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9124774932861328,
        0.06050638481974602,
        0.40462806820869446
      ],
      "plane_d": -1926.1268310546875,
      "bbox_min": [
        1962.5133056640625,
        -1949.0101318359375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1967.21337890625,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1967.93212890625,
        1364.038818359375,
        121.56649780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1967.2379150390625,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1967.93212890625,
        1353.199951171875,
        121.56649780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9124758243560791,
        -0.060545969754457474,
        -0.4046257734298706
      ],
      "plane_d": -1664.362548828125,
      "bbox_min": [
        1962.5133056640625,
        -1949.0101318359375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9144964218139648,
        -0.05990223586559296,
        -0.4001348912715912
      ],
      "plane_d": -1669.841796875,
      "bbox_min": [
        1962.5133056640625,
        -1930.575439453125,
        120.00121307373047
      ],
      "bbox_max": [
        1974.56298828125,
        1467.03125,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1962.5133056640625,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1974.11181640625,
        1453.431396484375,
        134.53643798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1962.5133056640625,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1974.11181640625,
        1453.431396484375,
        134.53643798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1453.431396484375,
      "bbox_min": [
        1969.311767578125,
        1453.431396484375,
        120.001220703125
      ],
      "bbox_max": [
        1974.11181640625,
        1453.431396484375,
        121.73780059814453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1963.1976318359375,
        -1930.575439453125,
        593.4994506835938
      ],
      "bbox_max": [
        1974.448974609375,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        1963.1976318359375,
        -1930.575439453125,
        593.4994506835938
      ],
      "bbox_max": [
        1974.448974609375,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8897264003753662,
        -0.23840099573135376,
        -0.38929685950279236
      ],
      "plane_d": -1949.6500244140625,
      "bbox_min": [
        1963.1976318359375,
        -1846.539306640625,
        593.4994506835938
      ],
      "bbox_max": [
        1974.448974609375,
        -1804.5487060546875,
        609.4977416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1967.4481201171875,
        -1930.575439453125,
        609.4977416992188
      ],
      "bbox_max": [
        1974.562744140625,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3581342101097107,
        -0.13814792037010193,
        -0.923393189907074
      ],
      "plane_d": 1032.841552734375,
      "bbox_min": [
        1967.4481201171875,
        -1949.0101318359375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35971036553382874,
        -0.1380680948495865,
        -0.922792375087738
      ],
      "plane_d": 1035.78515625,
      "bbox_min": [
        1991.5059814453125,
        -1804.6795654296875,
        109.97537994384766
      ],
      "bbox_max": [
        2008.634765625,
        1591.4339599609375,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        1991.6058349609375,
        1253.199951171875,
        109.97537994384766
      ],
      "bbox_max": [
        2008.634765625,
        1591.4339599609375,
        158.6023406982422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -3.0517577442878974e-07,
        1.0
      ],
      "plane_d": -109.97489929199219,
      "bbox_min": [
        1991.6165771484375,
        1564.9527587890625,
        109.97537994384766
      ],
      "bbox_max": [
        1996.7265625,
        1591.4339599609375,
        109.97538757324219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36148110032081604,
        0.09685850143432617,
        -0.9273348450660706
      ],
      "plane_d": 1466.046875,
      "bbox_min": [
        1991.5059814453125,
        -1804.6795654296875,
        609.4977416992188
      ],
      "bbox_max": [
        2008.548828125,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1991.5059814453125,
        -1804.6795654296875,
        616.1078491210938
      ],
      "bbox_max": [
        1991.548828125,
        -1804.5487060546875,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877953886985779,
        0.23788394033908844,
        -0.3939931392669678
      ],
      "plane_d": 2452.591552734375,
      "bbox_min": [
        1967.4481201171875,
        -1949.0101318359375,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1578.1998291015625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8877948522567749,
        0.2378837764263153,
        0.39399445056915283
      ],
      "plane_d": 1984.919921875,
      "bbox_min": [
        1967.46875,
        -1939.6346435546875,
        109.975341796875
      ],
      "bbox_max": [
        2015.648681640625,
        1578.1998291015625,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -3.0517577442878974e-07,
        1.0
      ],
      "plane_d": -109.97489929199219,
      "bbox_min": [
        1967.46875,
        -1874.328125,
        109.975341796875
      ],
      "bbox_max": [
        2015.62939453125,
        1578.1998291015625,
        616.1244506835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        1967.46875,
        -1874.328125,
        109.975341796875
      ],
      "bbox_max": [
        2015.62939453125,
        1564.9527587890625,
        616.1244506835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6483832597732544,
        -2.3233462798089022e-07,
        0.7613141536712646
      ],
      "plane_d": -1371.6317138671875,
      "bbox_min": [
        1967.46875,
        -1874.328125,
        109.975341796875
      ],
      "bbox_max": [
        2015.62939453125,
        1564.5213623046875,
        616.1244506835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -119.90119934082031,
      "bbox_min": [
        1974.0,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1975.8544921875,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1414.0,
      "bbox_min": [
        1974.0,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1975.8544921875,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1424.0,
      "bbox_min": [
        1974.0,
        1424.0,
        118.90119934082031
      ],
      "bbox_max": [
        1975.8544921875,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1353.199951171875,
      "bbox_min": [
        1967.470947265625,
        1353.199951171875,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        124.6704330444336
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1453.431396484375,
      "bbox_min": [
        1973.6605224609375,
        1453.431396484375,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        120.55892944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9141523838043213,
        0.0,
        0.4053707718849182
      ],
      "plane_d": -1853.696533203125,
      "bbox_min": [
        1967.46875,
        -1874.328125,
        118.90119934082031
      ],
      "bbox_max": [
        2015.62939453125,
        1467.03125,
        616.1244506835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1453.431396484375,
      "bbox_min": [
        1973.9078369140625,
        1453.431396484375,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1453.431396484375,
        121.01876068115234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162539839744568,
        0.0,
        0.40059787034988403
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1972.8514404296875,
        -1874.328125,
        118.90119934082031
      ],
      "bbox_max": [
        2015.62939453125,
        1467.028564453125,
        616.1244506835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.35966363549232483,
        -0.09637150913476944,
        -0.9280919432640076
      ],
      "plane_d": -318.3746337890625,
      "bbox_min": [
        1972.8514404296875,
        -1874.328125,
        118.90119934082031
      ],
      "bbox_max": [
        2008.548828125,
        1424.0,
        616.1244506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385160088539124,
        0.17108990252017975,
        0.7503501772880554
      ],
      "plane_d": 1157.9024658203125,
      "bbox_min": [
        1974.68017578125,
        -1871.556396484375,
        118.90119934082031
      ],
      "bbox_max": [
        2008.548828125,
        1424.0,
        577.501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -119.90119934082031,
      "bbox_min": [
        1974.68017578125,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1980.5,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.90119934082031,
      "bbox_min": [
        1974.68017578125,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1980.5,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1980.5,
      "bbox_min": [
        1974.68017578125,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1980.5,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1414.0,
      "bbox_min": [
        1974.68017578125,
        1414.0,
        118.90119934082031
      ],
      "bbox_max": [
        1980.5,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1424.0,
      "bbox_min": [
        1974.68017578125,
        1424.0,
        118.90119934082031
      ],
      "bbox_max": [
        1980.5,
        1424.0,
        119.90119934082031
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}